module.exports = __webpack_public_path__ + "c9d4b53bac04857d63b7f06fc4c2063d.png";